import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconLayerBlueSizeS from './IconLayerBlue_size_s';

const props: CreateIconArguments = {
  l: IconLayerBlueSizeS,
  m: IconLayerBlueSizeS,
  s: IconLayerBlueSizeS,
  xs: IconLayerBlueSizeS,
  name: 'IconLayerBlue',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
